export default {
  namespaced: true,

  state: {
    companiesGroupsList: [],
    companiesGroupData: {},
    editItem: null,
    isLoading: false,
    error: null
  },
  getters: {
    companiesGroupsList(state) {
      return state.companiesGroupsList
    },
    companiesGroupData(state) {
      return state.companiesGroupData
    },
    editItem(state) {
      // console.log(state.editItem)
      return state.editItem
    },
    isLoading(state) {
      return state.isLoading
    },
    error(state) {
      return state.error
    },
  },
  mutations: {
    SET_COMPANIES_GROUP(state, companiesGroupsList) {
      state.companiesGroupsList = companiesGroupsList 
    },
    SET_COMPANIES_GROUP_DATA(state, companiesGroupData) {
      state.companiesGroupData = companiesGroupData
      
    },
    GET_COMPANIES_GROUP(state, index) {
      let editItemIndex = state.companiesGroupsList.map(function(item) { return item.id; }).indexOf(parseInt(index));
      state.editItem = state.companiesGroupsList[editItemIndex]
    },
    SET_LOADING_STATUS(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    REMOVE_ROW(state, index) {
      let removeIndex = state.companiesGroupsList.map(function(item) { return item.id; }).indexOf(index);
      state.companiesGroupsList.splice(removeIndex, 1);
    },
  },
  actions: {
    deleteRow({commit}, dispatch_data) {
      commit('REMOVE_ROW', dispatch_data.id)
    },
  }
}
